module.exports = __webpack_public_path__ + "img/dapp.9a280b33.png";